import React from 'react';

export const FlagSk = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.9997 38.9994C30.9407 38.9994 38.9994 30.9407 38.9994 20.9997C38.9994 11.0588 30.9407 3 20.9997 3C11.0587 3 3 11.0588 3 20.9997C3 30.9407 11.0587 38.9994 20.9997 38.9994Z"
        fill="#2A81BC"
      />
      <path
        d="M4.0462 14.9998H37.9539C36.7171 11.4912 34.4221 8.45278 31.3855 6.3035C28.3489 4.15423 24.7203 3 21.0001 3C17.2798 3 13.6512 4.15423 10.6146 6.3035C7.57806 8.45278 5.28307 11.4912 4.0462 14.9998Z"
        fill="white"
      />
      <path
        d="M3 20.9997C3.00422 23.0446 3.35804 25.0739 4.0462 26.9996H37.9539C39.3487 23.1212 39.3487 18.8781 37.9539 14.9998H4.0462C3.35786 16.9254 3.00405 18.9547 3 20.9997Z"
        fill="#0A4EA2"
      />
      <path
        d="M37.9539 26.9996H4.0462C5.28307 30.5083 7.57806 33.5467 10.6146 35.696C13.6512 37.8453 17.2798 38.9995 21.0001 38.9995C24.7203 38.9995 28.3489 37.8453 31.3855 35.696C34.4221 33.5467 36.7171 30.5083 37.9539 26.9996Z"
        fill="#EE2024"
      />
      <path
        d="M24.0398 10.9724C24.0398 10.9724 24.3275 13.8553 24.3275 19.6212C24.2864 25.5103 19.8824 28.4909 16.65 30.0582C13.4177 28.4909 9.01365 25.5103 8.97253 19.6212C8.97253 13.8553 9.26031 10.9724 9.26031 10.9724H24.0398Z"
        fill="#EE1C25"
      />
      <path
        d="M15.9973 26.6667V19.4568C13.5563 19.4568 12.8625 19.6727 12.1328 19.8936C12.2014 19.157 12.2014 18.4155 12.1328 17.6788C12.8625 17.8998 13.5563 18.1156 15.9973 18.1156V16.1114C15.2264 16.1114 14.1627 16.1423 12.9396 16.5585C13.0086 15.8201 13.0086 15.0769 12.9396 14.3385C14.1627 14.7496 15.2264 14.7805 15.9973 14.7805C15.9973 14.1998 15.8174 12.951 15.5913 11.9181C16.2956 11.9808 17.0042 11.9808 17.7085 11.9181C17.4824 12.951 17.3025 14.1998 17.3025 14.7805C18.0734 14.7805 19.1371 14.7496 20.3602 14.3385C20.2912 15.0769 20.2912 15.8201 20.3602 16.5585C19.1371 16.1423 18.0734 16.1114 17.3025 16.1114V18.1156C19.7435 18.1156 20.4373 17.8998 21.167 17.6788C21.0983 18.4155 21.0983 19.157 21.167 19.8936C20.4373 19.6727 19.7435 19.4568 17.3025 19.4568V26.6667H15.9973Z"
        fill="white"
      />
      <mask
        id="mask0_sk"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="10"
        width="17"
        height="21"
      >
        <path
          d="M24.0398 10.9724C24.0398 10.9724 24.3275 13.8553 24.3275 19.6212C24.2864 25.5103 19.8824 28.4909 16.65 30.0582C13.4177 28.4909 9.01365 25.5103 8.97253 19.6212C8.97253 13.8553 9.26031 10.9724 9.26031 10.9724H24.0398Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_sk)">
        <path
          d="M12.6571 32.3348C12.2402 32.3347 11.8295 32.1635 11.4593 31.8357C11.0891 31.5078 10.7704 31.0329 10.5298 30.4507C10.2892 29.8686 10.1338 29.1962 10.0767 28.49C10.0196 27.7839 10.0624 27.0646 10.2015 26.3926C10.3406 25.7206 10.572 25.1155 10.8762 24.6281C11.1804 24.1407 11.5485 23.7853 11.9497 23.5916C12.3509 23.3979 12.7734 23.3717 13.1817 23.5151C13.5901 23.6585 13.9723 23.9674 14.2964 24.4158C14.5773 23.7566 14.935 23.224 15.3426 22.8579C15.7502 22.4917 16.1972 22.3015 16.65 22.3015C17.1028 22.3015 17.5498 22.4917 17.9574 22.8579C18.365 23.224 18.7227 23.7566 19.0036 24.4158C19.3277 23.9674 19.7099 23.6585 20.1183 23.5151C20.5266 23.3717 20.9491 23.3979 21.3503 23.5916C21.7515 23.7853 22.1196 24.1407 22.4238 24.6281C22.728 25.1155 22.9594 25.7206 23.0985 26.3926C23.2376 27.0646 23.2804 27.7839 23.2233 28.49C23.1662 29.1962 23.0108 29.8686 22.7702 30.4507C22.5296 31.0329 22.2109 31.5078 21.8407 31.8357C21.4705 32.1635 21.0598 32.3347 20.6429 32.3348H12.6571Z"
          fill="#0B4EA2"
        />
      </g>
      <path
        d="M24.0398 10.9724C24.0398 10.9724 24.3275 13.8553 24.3275 19.6212C24.2864 25.5103 19.8824 28.4909 16.65 30.0582C13.4177 28.4909 9.01365 25.5103 8.97253 19.6212C8.97253 13.8553 9.26031 10.9724 9.26031 10.9724H24.0398Z"
        stroke="white"
        strokeWidth="0.555"
      />
    </svg>
  );
};
